import React from "react";
import styled from "@emotion/styled";

// 매니저어드민 PART_LIST 와 동일 — 구성품 지정 목록
export const PART_LIST = [
  "박스",
  "하드케이스",
  "더스트백",
  "개런티카드",
  "구매영수증",
  "보증서",
  "북렛",
  "택",
  "자물쇠",
  "열쇠",
  "스트랩더스트백",
  "병행업체보증서",
  "여분링크",
  "보증 메달",
  "융",
  "쇼핑백",
  "레인커버",
  "여분스터드",
  "여분끈",
  "가죽샘플",
  "휴대용 파우치",
  "이너백",
  "폴리싱",
  "기타",
  "A/S",
];

/**
 * 구성품 다중 선택 — 지정 목록(PART_LIST)에서 칩으로 토글.
 * - value: 콤마조인 문자열(선택된 구성품), onChange(콤마문자열)
 * - etc/onEtcChange: "기타" 선택 시 자유입력
 */
function AccessoryPicker({ value, onChange, etc, onEtcChange }) {
  const selected = new Set(
    String(value || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)
  );

  const toggle = (part) => {
    const next = new Set(selected);
    const removing = next.has(part);
    if (removing) next.delete(part);
    else next.add(part);
    // PART_LIST 순서를 유지해 저장
    const ordered = PART_LIST.filter((p) => next.has(p));
    onChange(ordered.join(","));
    // "기타" 해제 시 자유입력값 초기화(고아 데이터 방지)
    if (part === "기타" && removing && onEtcChange) onEtcChange("");
  };

  return (
    <>
      <ChipGrid>
        {PART_LIST.map((part) => {
          const on = selected.has(part);
          return (
            <Chip
              key={part}
              type="button"
              selected={on}
              danger={part === "A/S"}
              onClick={() => toggle(part)}
            >
              <Mark selected={on}>{on ? "✓" : ""}</Mark>
              {part}
            </Chip>
          );
        })}
      </ChipGrid>
      {selected.has("기타") && (
        <EtcInput
          value={etc || ""}
          onChange={(e) => onEtcChange(e.target.value)}
          placeholder="기타 구성품 입력"
        />
      )}
    </>
  );
}

const ChipGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px;
  border: 1px solid
    ${({ selected, danger }) =>
      selected ? (danger ? "#dd3333" : "#003580") : "#e6e8eb"};
  border-radius: 16px;
  background: ${({ selected, danger }) =>
    selected ? (danger ? "#fdecea" : "#eef3fb") : "#fff"};
  color: ${({ selected, danger }) =>
    selected ? (danger ? "#dd3333" : "#003580") : "#555"};
  font-size: 13px;
  font-weight: ${({ selected }) => (selected ? 500 : 400)};
  cursor: pointer;
`;
const Mark = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  border: 1px solid ${({ selected }) => (selected ? "currentColor" : "#bbb")};
  border-radius: 3px;
  font-size: 9px;
  font-weight: bold;
  line-height: 1;
`;
const EtcInput = styled.input`
  width: 100%;
  height: 44px;
  margin-top: 8px;
  padding: 0 14px;
  font-size: 14px;
  border: 1px solid #d9dde2;
  border-radius: 10px;
  outline: none;
  &:focus {
    border-color: #003580;
  }
`;

export default AccessoryPicker;
